function defaultComparer(a: any, b: any) {
    return a === b;
}

export default function isArraysEqual<T>(srcArr?: T[], dstArr?: T[], comparer: (a: T, b: T) => boolean = defaultComparer): boolean {
    if (srcArr === dstArr) return true;
    if (!srcArr || !dstArr) return false;
    if (srcArr.length !== dstArr.length) return false;
    return srcArr.every(x => dstArr.find(y => comparer(x, y)) != null);
}